import { Problem, ProblemDetectionContext, ProblemType, ProblemSeverity } from '../types';

export function detectInputTimeouts(context: ProblemDetectionContext, generateId: () => string): Problem[] {
  const problems: Problem[] = [];
  const { logs } = context;

  const timeoutLogs = logs.filter(
    (log) => log.EventType === 'ExecutionResult' && log.LogData.Action?.ExecutionResult === 'Timeout'
  );

  timeoutLogs.forEach((timeoutLog) => {
    const originalIndex = logs.indexOf(timeoutLog);
    problems.push({
      id: generateId(),
      type: ProblemType.INPUT_TIMEOUT,
      severity: ProblemSeverity.MEDIUM,
      title: 'Input Timeout Detected',
      description: `Customer failed to provide input within timeout period for action "${timeoutLog.LogData.Action?.Type}"`,
      timestamp: timeoutLog.AbsoluteTime,
      source: 'IVR_LOG',
      relatedData: { log: timeoutLog },
      suggestions: [
        'Consider increasing timeout duration',
        'Review prompt clarity for customer',
        'Check if customers are experiencing technical difficulties'
      ],
      index: originalIndex >= 0 ? originalIndex : undefined
    });
  });

  return problems;
}
